import { action, observable } from "mobx";

/** @typedef {"idle" | "loading" | "ready"} ImportListBootstrapPhase */

const DEFAULT_TITLE = "Import from Contacts";

class ImportFromContactsListPopupStore {
  @observable visible = false;
  @observable sequence = null;
  @observable sequenceId = "";
  /** @type {ImportListBootstrapPhase} */
  @observable bootstrapPhase = "idle";
  @observable guardContext = null;
  /**
   * Heading text. The sequence page calls this "Import from Contacts"; the
   * copilot calls the same thing "Add contacts", because there it is reached
   * from an "Add contacts" action rather than an import menu. Same component,
   * same behaviour -- only the word changes.
   */
  @observable title = DEFAULT_TITLE;

  /** @type {(() => Promise<void>) | null} */
  afterGuardsFn = null;

  /** @type {(() => object | null) | null} */
  refreshSequenceFn = null;
  /** @type {(() => Promise<void>) | null} */
  onImportSuccessFn = null;

  @action
  open = ({
    sequence = {},
    sequenceId = "",
    guardContext = null,
    title = DEFAULT_TITLE,
    afterGuards = null,
    refreshSequence = null,
    onImportSuccess = null
  } = {}) => {
    this.sequence = sequence;
    this.sequenceId = sequenceId;
    this.guardContext = guardContext;
    this.title = title || DEFAULT_TITLE;
    this.afterGuardsFn = typeof afterGuards === "function" ? afterGuards : null;
    this.refreshSequenceFn =
      typeof refreshSequence === "function" ? refreshSequence : null;
    this.onImportSuccessFn =
      typeof onImportSuccess === "function" ? onImportSuccess : null;
    this.bootstrapPhase = "loading";
    this.visible = true;
    const body = document.getElementsByTagName("body")[0];
    if (body) {
      body.classList.add("scrollHidden");
    }
  };

  @action
  setSequence = value => {
    this.sequence = value || null;
  };

  @action
  setBootstrapPhase = phase => {
    this.bootstrapPhase = phase;
  };

  @action
  close = () => {
    this.visible = false;
    this.sequence = null;
    this.sequenceId = "";
    this.bootstrapPhase = "idle";
    this.guardContext = null;
    this.afterGuardsFn = null;
    this.refreshSequenceFn = null;
    this.onImportSuccessFn = null;
    const body = document.getElementsByTagName("body")[0];
    if (body) {
      body.classList.remove("scrollHidden");
    }
  };
}

const importFromContactsListPopupState = new ImportFromContactsListPopupStore();

export { importFromContactsListPopupState };
export default importFromContactsListPopupState;
